
<template>
  <div class="smart-captcha">
    <div
      ref="captchaContainer"
      class="captcha-container"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount, toRef, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useField } from 'vee-validate';


const { locale } = useI18n();

const props = defineProps<{
  name: string;
}>();

// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
const name = toRef(props, 'name');

const {
  value: inputValue,
  errorMessage,
  handleChange,
  meta,
} = useField(name, undefined, {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  initialValue: props.value,
});

const captchaToken = import.meta.env.VITE_CAPTCHA_SITE_KEY;

const captchaContainer = ref(null);
let captchaWidgetId = null;

function renderCaptcha() {
  if (!window.smartCaptcha || !captchaContainer.value) {
    handleChange(null);
    return;
  }

  captchaWidgetId = window.smartCaptcha.render(
    captchaContainer.value,
    {
      sitekey: captchaToken,
      hl: ['ru', 'en', 'es']
        .includes(locale.value)
        ? locale.value
        : 'ru',
      callback: (token) => handleChange(token),
      'error-callback': () => handleChange(null),
    }
  );
}

onMounted(renderCaptcha);

onBeforeUnmount(() => {
  if (captchaWidgetId !== null && window.smartCaptcha) {
    window.smartCaptcha.destroy(captchaWidgetId);
  }
});
</script>

<style>
  .smart-captcha {
    margin-bottom: 32px;
  }
</style>
